import _ from 'lodash';
import moment from 'moment';
import { Firebase, ifCallbackIsFunction, unwrapDoc, goalValueIsSet, unwrapDocs, logAndDispatchErrorForAction, withoutId, getCurrentTimestamp, accountId, organizationId, isProduction, omitDeleted, addKeysAsIds } from './../util';
import { OrganizationRef, DealsRef } from './../util/refs';

import {
  FETCH_DEALS,
  FETCH_DEALS_SUCCESS,
  FETCH_DEALS_ERROR,

  FETCH_DEAL,
  FETCH_DEAL_SUCCESS,
  FETCH_DEAL_ERROR,

  SAVE_DEAL,
  SAVE_DEAL_SUCCESS,
  SAVE_DEAL_ERROR,

} from './types';

export function createOrUpdateDeal(dealData, callback){
  if(dealData._id){
    return updateDeal(dealData, callback);
  }
  else{
    return createDeal(dealData, callback);
  }
}

export function createDeal(newDeal, callback){
  console.log('creating deal!');

  return dispatch => {

    dispatch({
      type: SAVE_DEAL,
      payload: newDeal,
    });

    DealsRef().add({
      ...newDeal,
      createdOn: getCurrentTimestamp(),
      lastUpdated: getCurrentTimestamp(),
    }).then(dealRef => {

      const newDealId = dealRef.id;

      console.log('deal created with id: ', newDealId);

      newDeal._id = newDealId;

      dispatch({
        type: SAVE_DEAL_SUCCESS,
        payload: newDeal
      });

      ifCallbackIsFunction(callback, newDeal);

    }).catch(err => logAndDispatchErrorForAction('Create deal object', err, dispatch, SAVE_DEAL_ERROR));
  }
}

export function updateDeal(updatedDeal, callback){

  console.log('updating deal!');

  const dealId = updatedDeal._id;

  return dispatch => {

    dispatch({
      type: SAVE_DEAL,
      payload: updatedDeal,
    });

    DealsRef().doc(dealId).update({
      ...withoutId(updatedDeal),
      lastUpdated: getCurrentTimestamp(),
    }).then(() => {

      console.log('update successful! new object: ', updatedDeal);

      dispatch({
        type: SAVE_DEAL_SUCCESS,
        payload: updatedDeal
      });

      ifCallbackIsFunction(callback, updatedDeal);

    }).catch(err => logAndDispatchErrorForAction('Update deal object', err, dispatch, SAVE_DEAL_ERROR));
  }
}

export function fetchDeal(dealId, callback){
  console.log('fetching deal with id: ', dealId);

  return dispatch => {

    dispatch({
      type: FETCH_DEAL,
    });

    DealsRef().doc(dealId).get().then(doc => {
      const deal = unwrapDoc(doc);

      dispatch({
        type: FETCH_DEAL_SUCCESS,
        payload: deal
      });

      ifCallbackIsFunction(callback, deal);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch deal ${dealId}`, err, dispatch, FETCH_DEAL_ERROR, callback) });
  }
}

async function fetchTeamMemberDeals(memberId){
  const memberDeals = await DealsRef().where('userId', '==', memberId).get().then(docs => {
    return unwrapDocs(docs);
  });

  return memberDeals;
}

export function fetchDealsForTeam(team, callback){
  console.log(`fetching deals for team:`, team);

  return async dispatch => {

    dispatch({
      type: FETCH_DEALS
    });

    try{

      let fetchTeamMemberDealsFunctions = _.map(team.members, memberId => {
        return fetchTeamMemberDeals(memberId);
      });

      const allTeamMemberDealsArray = await Promise.all(fetchTeamMemberDealsFunctions);

      const allTeamMemberDeals = _.reduce(allTeamMemberDealsArray, (memo, dealsForMember) => {
        return _.union(memo, dealsForMember);
      }, []);

      console.log('found all team member deals! :::', allTeamMemberDeals);

      return dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: allTeamMemberDeals
      });
    }
    catch(err){
      return dispatch({
        type: FETCH_DEALS_ERROR,
        payload: err.message
      });
    }
  }
}
  //
  // return dispatch => {
  //   dispatch({
  //     type: FETCH_DEALS,
  //   });
  //
  //   let db = Firebase.firestore();
  //
  //   let batch = db.batch();
  //
  //   _.each(team.members, memberId => {
  //
  //     batch.get
  //
  //     const newEpisodeRef = EpisodesRef().doc();
  //     batch.set(newEpisodeRef, {
  //       ...episode,
  //       createdOn: getCurrentTimestamp(),
  //     });
  //   });
  //
  //   batch.commit().then(() => {
  //     callback();
  //   });
  //
  //   const batch = admin.firestore().batch();
  //
  //   let batch = firestore.batch();
  //
  //   ref.get().then(snap => {
  //
  //     snap.forEach(doc => {
  //       batch.delete(doc.ref);
  //     });
  //
  //     batch.commit().then(() => {
  //       console.log('Items deleted for ref: ', ref.id);
  //       callback();
  //     });
  //   });
  // }

  // console.log('fetching deals for user: ', employeeId);
  //
  // return dispatch => {
  //
  //   dispatch({
  //     type: FETCH_DEALS,
  //   });
  //
  //   DealsRef().where('userId', '==', employeeId).orderBy('createdOn', 'desc').get().then(docs => {
  //     const deals = unwrapDocs(docs) || [];
  //
  //     dispatch({
  //       type: FETCH_DEALS_SUCCESS,
  //       payload: deals
  //     });
  //
  //     ifCallbackIsFunction(callback, deals);
  //
  //   }).catch(err => { logAndDispatchErrorForAction(`Fetch deals for user ${employeeId}`, err, dispatch, FETCH_DEALS_ERROR, callback) });
  // }
//}

export function fetchDealsForEmployee(employeeId, callback){
  console.log('fetching deals for user: ', employeeId);

  return dispatch => {

    dispatch({
      type: FETCH_DEALS,
    });

    DealsRef().where('userId', '==', employeeId).orderBy('createdOn', 'desc').get().then(docs => {
      const deals = unwrapDocs(docs) || [];

      dispatch({
        type: FETCH_DEALS_SUCCESS,
        payload: deals
      });

      ifCallbackIsFunction(callback, deals);

    }).catch(err => { logAndDispatchErrorForAction(`Fetch deals for user ${employeeId}`, err, dispatch, FETCH_DEALS_ERROR, callback) });
  }
}



// WEBPACK FOOTER //
// ./src/actions/deals.js